import { Routes } from '@angular/router';
import { GalleryType01Component } from './gallery-type01/gallery-type01.component';
export default [
    {
        path     : '',
        component: GalleryType01Component,
    },
    
] as Routes;
